import CardsList from "@/components/cardsList";
import { USE_CASES_CONSTANTS } from "./constants";

const UseCasesComp = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      title={USE_CASES_CONSTANTS.title}
      list={USE_CASES_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
    />
  );
};

export default UseCasesComp;
